// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nM-z","twoColumnImage":"oM-z"};